export default "__VITE_ASSET__Cwg$e5mM__"